import ApiService from '@/helpers/api.service';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();

const BUSINESS_CATEGORY_ENDPOINT = '/e-seller/business-category';
const PRODUCT_ENDPOINT = '/e-seller/product';
const BRAND_ENDPOINT = '/e-seller/brand';
const BANNER_ENDPOINT = '/e-seller/banner';

export const state = {
  brands: [],
  brandPage: {
    totalRows: 0
  },
  bussinessCategories: [],
  bussinessCategoryPage: {
    totalRows: 0
  },
  products: [],
  productPage: {},
  banners: [],
  bannerPage: {
    totalRows: 0
  },
  errors: null
}

export const mutations = {
  UPDATE_SELLER_BRAND_LIST(state, brands){
    state.brands = brands;
  },
  UPDATE_SELLER_BRAND_PAGE(state, pageInfo){
    state.brandPage = pageInfo;
    console.log(state.brandPage);
  },
  UPDATE_SELLER_CATEGORY_LIST(state, bussinessCategories){
    state.bussinessCategories = bussinessCategories;
  },
  UPDATE_SELLER_CATEGORY_PAGE(state, pageInfo){
    state.bussinessCategoryPage = pageInfo
  },
  UPDATE_SELLER_PRODUCT_LIST(state, products){
    state.products = products;
  },
  UPDATE_SELLER_PRODUCT_PAGE(state, pageInfo){
    state.productPage = pageInfo
  },
  SET_ESELLER_ERROR(state, errors){
    state.errors = errors;
  },
  UPDATE_SELLER_BANNER_LIST(state, banners) {
    state.banners = banners;
  },
  UPDATE_SELLER_BANNER_PAGE(state, pageInfo) {
    state.bannerPage = pageInfo;
    
  }
}

export const actions = {
  listSellerBrands(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BRAND_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_SELLER_BRAND_LIST', data.message.rows);
            context.commit('UPDATE_SELLER_BRAND_PAGE', {
              totalRows: data.message.pageInfo.total,
              noOfPage: data.message.pageInfo.noOfPage
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
          reject();
        });
    });
  },
  createSellerBrand(context, params){
    console.log(params);
    return new Promise((resolve, reject) => {
      API.post(`${BRAND_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
            console.log("create brand err");
          } else {
            resolve();
            console.log("create brand resolve");
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  getSellerBrand(context, id){
    return new Promise((resolve, reject) => {
      API.post(`${BRAND_ENDPOINT}/info`, {id: id})
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  updateSellerBrand(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BRAND_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  listSellerCategories(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BUSINESS_CATEGORY_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_SELLER_CATEGORY_LIST', data.message.rows);
            context.commit('UPDATE_SELLER_CATEGORY_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createSellerCategory(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BUSINESS_CATEGORY_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  updateSellerCategory(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BUSINESS_CATEGORY_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
          reject();
        });
    });
  },
  deleteSellerCategory(context, businessCategoryId){
    return new Promise((resolve, reject) => {
      var params = { businessCategoryId: businessCategoryId };
      API.post(`${BUSINESS_CATEGORY_ENDPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
          reject();
        });
    });
  },
  listSellerProducts(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PRODUCT_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_SELLER_PRODUCT_LIST', data.message.rows);
            context.commit('UPDATE_SELLER_PRODUCT_PAGE', data.message.pageInfo);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
          reject();
        });
    });
  },
  uploadLogo(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }
      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(30, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      Storage.put(`${params.folder}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  },

  listSellerBanners(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BANNER_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            console.log(data.message.rows);
            context.commit('UPDATE_SELLER_BANNER_LIST', data.message.rows);
            context.commit('UPDATE_SELLER_BANNER_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
          reject();
        });
    });
  },
  createSellerBanner(context, params){
    console.log(params);
    return new Promise((resolve, reject) => {
      API.post(`${BANNER_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  deleteSellerBanner(context, id){
    return new Promise((resolve, reject) => {
      API.post(`${BANNER_ENDPOINT}/delete`, {bannerId: id})
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  updateSellerBanner(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BANNER_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({response}) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
        })
    });
  },
  esellerOrders(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/e-seller/order/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data.message)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ESELLER_ERROR', response.data.errors);
          reject(response.data.errors);
        });
    });
  },
}

export const getters = {}